export default "__VITE_ASSET__Bb7x3DMw__"